// extracted by mini-css-extract-plugin
module.exports = {"main_group":"styles_main_group__wLQgE","main_group_sm":"styles_main_group_sm__oS6GD"};